// .pg-event-detail-fixed-visual（イベント詳細のヘッダー直下固定ビジュアル・SP専用）の表示制御
//
// 初期状態は非表示。ページ先頭では本体の .pg-event-detail-visual が通常フローで見えているため、
// 固定版まで出すと同じ画像が二重に見えて違和感が出る。
// 本体を通り過ぎたあとの「上スクロール」でのみ表示し、下スクロールでは即座に退避させる。
//
// 追従・退避の指定は SCSS 側の @include md 内にのみ存在するため、
// PC で data-hidden を操作しても見た目は変化しない（JS側でのBP判定は不要）。

// 慣性スクロールの微振動で表示が誤爆しないための遊び
const THRESHOLD = 4;

const main = () => {
    const el = document.querySelector(".pg-event-detail-fixed-visual");
    if (!el) return;

    // 通常フロー側の本体ビジュアル。これを通り過ぎるまでは固定版を出さない
    const source = document.querySelector(".pg-event-detail-layout__visual");

    let lastY = window.scrollY;

    // 本体が固定表示位置より上へ流れ切ったか。
    // 本体がまだ見えている状態で固定版を出すと同じ画像が二重に見えるため、
    // 「本体の下端 <= 固定版の表示位置(top)」を条件にする。
    // top は SCSS の calc(ヘッダー高 + --area-bar-height) を computed から読むので、
    // エリアバーの高さが変わっても追随する（PCでは top:auto → 0 として扱われるが、
    // PCには表示指定自体が無いため影響しない）
    const isSourceOutOfView = () => {
        if (!source) return true;
        const topOffset = parseFloat(getComputedStyle(el).top) || 0;
        return source.getBoundingClientRect().bottom <= topOffset;
    };

    const onScroll = () => {
        const currentY = window.scrollY;
        const delta = currentY - lastY;

        // 微小な変化では切り替えない。lastY を更新せず持ち越すので、
        // ゆっくりスクロールでも累積して必ず判定される
        if (Math.abs(delta) < THRESHOLD) return;

        const isScrollingUp = delta < 0;

        el.toggleAttribute("data-hidden", !(isScrollingUp && isSourceOutOfView()));
        lastY = currentY;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
};

export default main;
